<template>
  <div class="bigbanner">
    <a href="contact" target="_blank">
      <img src="images/banner/banner_23_eco.jpg" />
    </a>
    <!-- <a href="contact" target="_blank">
      <img src="images/banner/banner_23_07.jpg" />
    </a> -->
  </div>
  <div class="bannerspace">
    <a href="https://www.instagram.com/nagai.home/" target="_blank">
      <img src="@/assets/images/common/banner_insta.jpg" />
    </a>
  </div>
</template>

<script>
export default {
  components: {},
  setup() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.bigbanner {
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  width: 100%;
  text-align: center;
  padding: 2rem $h-gap;
  margin-top: 4rem;
  margin-bottom: 1rem;
  background: repeating-linear-gradient(
    -45deg,
    #eee,
    #eee 2px,
    #fff 0,
    #fff 8px
  );

  @include tb {
    flex-direction: column;
    padding: 1rem $h-gap;
  }
  a {
    outline: 1px solid $color_sub;
    margin: 0 auto;
    display: block;
    max-width: 560px;
    border-radius: 0.5rem;
    overflow: hidden;
    img {
      width: 100%;
      height: auto;
      transition: 0.2s;
      &:hover {
        opacity: 0.8;
      }
    }
  }
}
.bannerspace {
  width: 100%;
  text-align: center;
  padding: 0 $h-gap;
  margin-bottom: 1rem;

  @include tb {
    margin-bottom: $v-gap;
  }
  a {
    outline: 1px solid $color_sub;
    margin: 0 auto;
    display: block;
    max-width: 480px;
    border-radius: 0.5rem;
    overflow: hidden;
    img {
      width: 100%;
      height: auto;
      transition: 0.2s;
      &:hover {
        opacity: 0.8;
      }
    }
  }
}
</style>
